<template>
  <div
    :class="`input-wrapper -${inkline.options.colorMode === 'system' ? colorMode : inkline.options.colorMode}
    ${error ? '-error' : ''}`" :am-input-cond="error"
  >
    <div class="input">
    <input
      v-model="inputValue"
      :placeholder="placeholder"
      ref="input"
      :type="type ? type : null"
      :style="`min-width: 70px; width:${widthArea + 10}px; max-width: 500px`"
    />
    </div>
    <ul class="form-error" v-if="error" am-error>
      <li>{{ errorMessage }}</li>
    </ul>
  </div>
</template>

<script>
import colorMode from '@/_mixins/colorMode'
export default {
  inject: ['inkline'],
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    widthArea: 0
  }),
  mixins: [colorMode],
  mounted () {
    this.resize()
  },
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
        this.resize()
      }
    }
  },
  methods: {
    resize () {
      if (this.$refs.input.scrollWidth > this.$refs.input.clientWidth) {
        this.widthArea = this.$refs.input.scrollWidth
      }
    }
  }
}
</script>

<style lang="scss">
[am-input-cond~='true'] {
  position: initial !important;
  // margin-bottom: 30px;
  [am-error] {
    position: absolute;
    width: calc(100% + 65px);
  }
}
[am-input-cond] {
  input[type=number] {
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button {
      display: none;
    }
  }
}
</style>
